<modal
  [id]="id"
  [showFooterDivider]="false"
  [showHeaderDivider]="false"
  [widthClass]="'tw-w-[343px] lg:tw-w-[416px]'"
  [heightClass]="'tw-h-auto'"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="true"
  (onCloseModal)="onCloseModal()"
>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-justify-center tw-py-2" slot="body">
    <span>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_16008_2748)">
          <path
            d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 15C9.80222 15 9.60888 14.9413 9.44443 14.8315C9.27998 14.7216 9.15181 14.5654 9.07612 14.3827C9.00044 14.2 8.98063 13.9989 9.01922 13.8049C9.0578 13.6109 9.15304 13.4327 9.2929 13.2929C9.43275 13.153 9.61093 13.0578 9.80491 13.0192C9.99889 12.9806 10.2 13.0004 10.3827 13.0761C10.5654 13.1518 10.7216 13.28 10.8315 13.4444C10.9414 13.6089 11 13.8022 11 14C11 14.2652 10.8946 14.5196 10.7071 14.7071C10.5196 14.8946 10.2652 15 10 15ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12C9.73479 12 9.48043 11.8946 9.2929 11.7071C9.10536 11.5196 9 11.2652 9 11V6C9 5.73478 9.10536 5.48043 9.2929 5.29289C9.48043 5.10536 9.73479 5 10 5C10.2652 5 10.5196 5.10536 10.7071 5.29289C10.8946 5.48043 11 5.73478 11 6V11Z"
            fill="#9CA3AF"
          />
        </g>
        <defs>
          <clipPath id="clip0_16008_2748">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
    <p class="tw-font-inter tw-text-gray-500 tw-px-4 tw-text-center tw-text-base tw-leading-6 tw-font-normal">
      You have unsaved changes. If you leave this page, your updates will be lost.
    </p>
  </div>
  <div class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-pt-4 tw-pb-6" slot="footer">
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-4 focus:tw-ring-blue-300 tw-font-medium tw-rounded-md tw-text-sm focus:tw-outline-none tw-px-3 tw-py-2 tw-font-inter"
      (mousedown)="$event.preventDefault()"
      (click)="onSaveChanges()"
    >
      Save changes
    </button>
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-border tw-text-red-700 tw-bg-white hover:tw-bg-red-100 tw-font-medium tw-rounded-md tw-text-sm focus:tw-outline-none tw-border-red-700 tw-px-3 tw-py-2 tw-font-inter"
      (mousedown)="$event.preventDefault()"
      (click)="discardChanges()"
    >
      Discard changes
    </button>
  </div>
</modal>
